import { ReactNode } from 'react';
import Maintenance from '../Maintenance';
import { useSelector } from 'react-redux';
import { AppState } from '../../../redux/store';

const MaintenanceGate = ({ children }: { children: ReactNode }) => {
  const { isMaintenance, maintenance } = useSelector(
    (state: AppState) => state.maintenance
  );
  if (!isMaintenance || maintenance === null) {
    return <>{children}</>;
  }
  return (
    <Maintenance
      title={maintenance.title}
      message={maintenance.body}
      startAt={new Date(maintenance.startAt)}
      endAt={new Date(maintenance.endAt)}
    />
  );
};

export default MaintenanceGate;
